import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ApplicationItem } from '../application-item';
import { Pagination } from '../pagination';
export const ApplicationList = (param)=>{
    let { applicationList, authUserName, paginationProps, gitTags } = param;
    const renderPagination = paginationProps && /*#__PURE__*/ _jsx("div", {
        className: "w-full flex justify-end mt-3",
        children: /*#__PURE__*/ _jsx(Pagination, {
            count: paginationProps.applicationListCount,
            page: paginationProps.page,
            showFirstButton: true,
            showLastButton: true,
            onChange: paginationProps.onPageChange
        })
    });
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "overflow-hidden rounded-lg border border-border",
                children: applicationList.map((app)=>/*#__PURE__*/ _jsx(ApplicationItem, {
                        application: app,
                        authUserName: authUserName,
                        gitTags: gitTags
                    }, "application-".concat(app.id)))
            }),
            renderPagination
        ]
    });
};
